import { useMemo } from "react";
import { Column } from "react-table";
import { Title } from "@funcional/react-ui";
import { IntlMoney } from "@funcional/react-intl-ui";
import { useI18n } from "@common/helpers";
import {
  DefaultColumnFilter,
  GridView,
  SelectColumnFilter,
} from "@funcional/react-table-ui";
import { useParams } from "react-router-dom";
import { useTransactions } from "../hooks/useTransactions";
import { ToolTipRefundAmount } from "../components/TooltipRefundAmount";
import { ToolTipProducts } from "../components/TooltipProducts";
import { ToolTipProcessStatus } from "../components/TooltipProcessStatus";
import { TransactionModal } from "../components/TransactionModal";
import { formatDate } from "@refund/helpers";
import { IProgramParams, IRefundTransaction } from "../contracts";
import TransactionStatus from "../components/TransactionStatus";

export default function ListTransactions() {
  const { intlEnum } = useI18n();
  const program: IProgramParams = useParams();

  const columns: Column<IRefundTransaction>[] = useMemo(
    () => [
      {
        Header: "ID",
        accessor: "pbmSaleId",
        Filter: DefaultColumnFilter,
        Cell: ({ value }) => <>{value}</>
      },
      { 
        Header: "CNPJ",
        Filter: DefaultColumnFilter,
        accessor: "establishmentCode",
        Cell: ({value}) => <>{value}</>
      },
      {
        Header: "Status",
        accessor: "canceledTransactionDate",
        Filter: SelectColumnFilter,
        options: [
          { value: "sold", description: "OK" },
          { value: "canceled", description: "CANCELADA" },
        ],
        Cell: ({ value }) => <TransactionStatus value = { value }/>
      },
      {
        Header: "Data",
        accessor: "transactionDate",
        Filter: DefaultColumnFilter,
        Cell: ({ value }) => <>{formatDate(value as any, "pt-BR")}</>
      },
      // { Essa parte será ativada, quando o valor total da transação estiver vindo do back-end
      //   Header: "Valor",
      //   accessor: "saleAmount",
      //   Cell: ({ value }) => <IntlMoney value={value} />
      // },
      { 
        Header: "EAN",
        acessor: "pbmSalesProducts",
        Filter: DefaultColumnFilter,
        Cell: ({ row }: any) => <ToolTipProducts row = {row} item = {"productCode"} />
      },
      { 
        Header: "Produto", 
        Filter: DefaultColumnFilter,
        Cell: ({ row }) => <ToolTipProducts row = {row} item = {"productName"} /> 
      },
      { 
        Header: "Processamento", 
        Filter: SelectColumnFilter,
        options: [
          { value: "CALCULATED", description: "CALCULADA" },
          { value: "RECALCULATED", description: "RECALCULADA" },
          { value: "NO_RULE", description: "SEM REGRA" },
          { value: "NO_FORMULA", description: "SEM FÓRMULA" },
        ],
        Cell: ({ row }) => <ToolTipProcessStatus row = {row} item = {"refundStatus"} /> 
      },
      {
        Header: "Ressarcimento",
        Cell: ({ row }) => <ToolTipRefundAmount row = {row} item = {"refundAmount"} />
      },
      {
        Header: "Resumo",
        Cell: ({ row }) => <TransactionModal row = {row} />
      },
    ],
    [intlEnum]
  );

  return (
    <>
      <div className="flex items-center w-full mb-4">
        <div className="flex-1">
          <Title marginBottom={0}>Transações do programa {program.programName}</Title>
        </div>
      </div>
      <hr className="mb-2" />

      <GridView<IRefundTransaction>
        paginationType="cursor"
        accessControlResourceName="transactions"
        columns={columns}
        hook={useTransactions}
        paginated
      />
    </>
  );
}
